require('script-loader!.tmp/js/templates/location/modules/Collapser.js');

export default class Collapser {
  static nextId() {
    if (!this._lastCount) this._lastCount = 0;
    this._lastCount++
    return `js-Collapser-${this._lastCount}`;
  }

  static run(scope = document, query = `(max-width: ${(768 - 1)/16}rem)`) {
    Array.from(scope.querySelectorAll('.Collapser'))
    .forEach((element) => {
      element.Collapser = new this(element, query);
    });
  }

  constructor(el, mediaQuery) {
    this.element = el;
    this.targetId = Collapser.nextId();
    this.detailsContent = '';
    this.toggleContent = '';
    this.ya = (!this.element.dataset.yaParent) ? 'collapse' : this.element.dataset.yaParent;
    this.nodeType = this.element.nodeName;
    // TODO: determine how to handle mutation of child nodes
    // probably would "just work" if i didn't try to use a soy template
    Array.from(this.element.querySelectorAll('[data-collapser-details]'))
    .forEach(node => this.detailsContent += node.outerHTML);

    Array.from(this.element.querySelectorAll('[data-collapser-toggle]'))
    .forEach(node => this.toggleContent += node.outerHTML);

    this.collapsedContent = this.render();

    this.mediaQueryMatcher = window.matchMedia(mediaQuery);
    this.mediaQueryMatcher.addListener(mq => this.swap(mq));
    this.swap(this.mediaQueryMatcher);
  }
  render() {
    let temp = document.createElement(this.nodeType);
    Array.from(this.element.classList).forEach(className => temp.classList.add(className));
    temp.dataset.yaParent = this.ya;
    temp.innerHTML = location.Collapser(this);
    return temp;
  }
  swap(queryStatus) {
    if (queryStatus.matches && this.element.parentNode) {
      this.element.parentNode.replaceChild(this.collapsedContent, this.element);
    } else if (!queryStatus.matches && this.collapsedContent.parentNode){
      this.collapsedContent.parentNode.replaceChild(this.element, this.collapsedContent);
    }
  }
}
